module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createSuccess"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toindex()
      }
    }
  }, [_vm._v("\n          查看我的保单\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("参保成功")]), _vm._v(" "), _c('p', {
    staticClass: "msg2"
  }, [_vm._v("WiFi安全险保障中")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d3d3ecf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/createSuccess.vue
// module id = 817
// module chunks = 1